<template>
  <div class="tw:w-max-content tw:flex">
    <BaseButton
      class="tw:border-0! tw:bg-transparent! tw:p-0! tw:text-xs! tw:font-bold tw:text-denim-900"
      icon="info"
      icon-right
      :label="label"
      new-design
      plain
    />
    <StreemTooltip>
      {{
        getLocaleText(
          "manage_social_connections.hashtags_limitation_streem_tooltip"
        )
      }}
    </StreemTooltip>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, StreemTooltip } from "shared/components/base";
import { INSTAGRAM_MONITOR_MAX_HASHTAG_COUNT } from "shared/constants/social";

type ManageSocialConnectionsHashtagsUsedProps = {
  count?: number;
};

const props = withDefaults(
  defineProps<ManageSocialConnectionsHashtagsUsedProps>(),
  {
    count: 0,
  }
);

const label = computed<string>(() =>
  getLocaleText("manage_social_connections.hashtags_used", {
    count: props.count,
    totalCount: INSTAGRAM_MONITOR_MAX_HASHTAG_COUNT,
  })
);
</script>
